import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, withKeys as _withKeys, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/LoginBanner.png'


const _withScopeId = n => (_pushScopeId("data-v-3c6e1854"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__title pt_0" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login-banner",
  src: _imports_0,
  alt: "EventMaster"
}, null, -1))
const _hoisted_5 = { class: "secondary-login" }
const _hoisted_6 = { class: "secondary-login" }
const _hoisted_7 = { class: "social-media" }
const _hoisted_8 = { class: "d-flex justify-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons facebook-icon" }, "facebook", -1))
const _hoisted_10 = { class: "d-flex align-center justify-center" }
const _hoisted_11 = { class: "gray__base__color" }
const _hoisted_12 = { class: "d-flex align-center justify-center" }
const _hoisted_13 = { class: "already-account" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      gutter: 20,
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "app__header__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("register.registration")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "text--center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("login.signUp")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "signUp__container"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_card, { class: "box-card mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, null, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("welcome.title")) + " EVENTMASTER ", 1),
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("welcome.event")), 1)
                        ]),
                        _: 1
                      }),
                      (!_ctx.isEventEnded)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createVNode(_component_el_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("login.signUpSocial")), 1),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "login-google mr-1",
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.googleLoginAction && _ctx.googleLoginAction(...args)))
                                  }, " Google "),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "login-fb ml-1",
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.facebookLoginAction && _ctx.facebookLoginAction(...args)))
                                  }, [
                                    _hoisted_9,
                                    _createTextVNode(" Facebook ")
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, false]
                            ]),
                            _createVNode(_component_el_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_divider, { "content-position": "center" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$t("login.or")), 513), [
                                      [_vShow, false]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form, {
                                  model: _ctx.form,
                                  ref: "loginform"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      prop: "email.value",
                                      rules: _ctx.form.email.rules
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, _mergeProps({
                                          class: "login-input",
                                          size: "large",
                                          "data-test": "email"
                                        }, _ctx.form.email.props, {
                                          modelValue: _ctx.form.email.value,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email.value) = $event))
                                        }), null, 16, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"]),
                                    _createVNode(_component_el_form_item, {
                                      prop: "password.value",
                                      rules: _ctx.form.password.rules
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, _mergeProps({
                                          rules: _ctx.form.password.props.rules,
                                          class: "login-input",
                                          size: "large",
                                          autocomplete: "off",
                                          "data-test": "password"
                                        }, _ctx.form.password.props, {
                                          modelValue: _ctx.form.password.value,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password.value) = $event)),
                                          "show-password": ""
                                        }), null, 16, ["rules", "modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"]),
                                    _createVNode(_component_el_form_item, {
                                      prop: "passwordConfirm.value",
                                      rules: _ctx.form.passwordConfirm.rules
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, _mergeProps({
                                          rules: _ctx.form.passwordConfirm.props.rules,
                                          class: "login-input",
                                          size: "large",
                                          autocomplete: "off",
                                          "data-test": "passwordConfirm"
                                        }, _ctx.form.passwordConfirm.props, {
                                          modelValue: _ctx.form.passwordConfirm.value,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.passwordConfirm.value) = $event)),
                                          "show-password": "",
                                          onKeyup: _withKeys(_ctx.registerUser, ["enter"])
                                        }), null, 16, ["rules", "modelValue", "onKeyup"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _: 1
                                }, 8, ["model"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { class: "text-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  class: "login-button secondary__color__button",
                                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.registerUser()), ["prevent"])),
                                  disabled: !_ctx.validForm
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("login.signUp")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("drawer.alreadyAccount")), 1),
                                  _createVNode(_component_el_button, {
                                    text: "",
                                    class: "signin secondary__color__link",
                                    onClick: _ctx.goLogin
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("login.signIn")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (_openBlock(), _createBlock(_component_el_col, {
                            key: 1,
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("register.eventHasEnded")), 1),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("drawer.alreadyAccount")), 1),
                                _createVNode(_component_el_button, {
                                  text: "",
                                  class: "signin",
                                  onClick: _ctx.goLogin
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("login.signIn")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}